export default __webpack_public_path__ + "static/media/conectividad.b2fed0be.jpg";